import React from "react";
import { Box, Button, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Modal from "../../../../components/Modal/Modal";

const ItemVersionDeployModal = ({ onClose, onDeploy, open, courseNames }) => {
  const { t } = useTranslation();

  return (
    <Modal
      scrollable
      disableEnforceFocus
      showCloseIcon
      maxWidth="sm"
      fullWidth
      dialogTitle={
        <Typography variant="h4" color="textPrimary">
          {t(`itemVersionDeployModal.title`)}
        </Typography>
      }
      dialogContent={
        <>
          <Box
            display="flex"
            justifyContent="space-between"
            mb={5.5}
            flexDirection={{ xs: "column", sm: "row" }}
            flexWrap="wrap"
          >
            <Typography variant="body1">
              {t(`itemVersionDeployModal.description`)}
            </Typography>
            <ul>
              {courseNames.map(name => {
                return (
                  <li key={name}>
                    <Typography variant="body1">{name}</Typography>
                  </li>
                );
              })}
            </ul>
          </Box>
        </>
      }
      dialogActions={
        <>
          <Button
            color="primary"
            onClick={onClose}
            data-qa="item-version-deploy-modal-cancel-btn"
          >
            {t("itemVersionDeployModal.cancelBtn")}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={onDeploy}
            data-qa="item-version-deploy-modal-continue-btn"
          >
            {t("itemVersionDeployModal.continueBtn")}
          </Button>
        </>
      }
      open={open}
      onClose={onClose}
      data-qa="item-version-deploy-modal"
    />
  );
};

export default ItemVersionDeployModal;

ItemVersionDeployModal.propTypes = {
  onClose: PropTypes.func,
  onDeploy: PropTypes.func,
  open: PropTypes.bool,
  courseNames: PropTypes.arrayOf(PropTypes.string)
};
